import Tooltip from 'legacy/components/generic/Tooltip';

import { AttributeAdjustmentBadge as theme } from 'legacy/css-modules';

const AttributeAdjustmentBadge = ({
  original,
  adjusted,
  originalDisplay,
  adjustedDisplay,
  label
}) => {
  return (
    <Tooltip
      trigger={<div className={theme.AttributeAdjustmentBadge}>Adjusted</div>}
      content={
        <div>
          <div className={theme.TooltipLabel}>Original Value</div>
          <div className={theme.Value}>
            {label}: {originalDisplay}
          </div>
        </div>
      }
      transparentScreen
    />
  );
};

export default AttributeAdjustmentBadge;
